import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
// import editIcon from '../../assets/images/icons/icon-edit.svg';
// import delIcon from '../../assets/images/icons/icon-delete.svg';
import { toast } from 'react-toastify';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
// import DeleteAgencyModal from '../Modals/AgencyModals/DeleteAgencyModal';
// import DetailAgencyModal from '../Modals/AgencyModals/DetailAgencyModal';
// import EditAgencyModal from '../Modals/AgencyModals/EditAgencyModal';
import DataTable from 'react-data-table-component';
import warningIcon from '../../assets/images/status-icon.svg';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
const Agencies = () => {
    const [agencies, setAgencies] = useState();
    const [activeNumber, setActiveNumber] = useState(1);
    const [selectedItem, setSelectedItem] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showBulkDel, setShowBulkDel] = useState(false);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const navigate = useNavigate();
    const { getToken } = useAuth();
    /*Pagination against Table */
    let items = [];
    // for (let number = 1; number <= paginationBtns; number++) {
    //     items.push(
    //         <Pagination.Item
    //             key={number}
    //             active={number === activeNumber}
    //             onClick={() => {
    //                 setActiveNumber(number);
    //             }}
    //         >
    //             {number}
    //         </Pagination.Item>
    //     );
    // }

    useEffect(() => {
        setOffset((s) => {
            if (activeNumber == 1) {
                return 0;
            } else if (activeNumber == 2) {
                return 10;
            } else if (activeNumber == 3) {
                return 20;
            } else if (activeNumber == 4) {
                return 40;
            } else if (activeNumber == 5) {
                return 50;
            }
        });
    }, [activeNumber]);

    const calcPagination = (total) => {
        // if (total) {
        // const t = (total / 10).toFixed(1);
        //     if (t > parseInt(t)) {
        //         setPaginationBtns(parseInt(t) + 1);
        //     } else {
        //         setPaginationBtns(parseInt(t));
        //     }
        // } else {
        //     setPaginationBtns(1);
        // }
    };

    useEffect(() => {
        getAllAgencies(offset);
    }, [offset]);

    const handleClose = () => {
        setShowDelModal(false);
        setShowEditModal(false);
        setShowDetailModal(false);
        setChangeStatusModal(false);
        setShowBulkDel(false);
    };

    const getAllAgencies = async (pageSize = 10, pageNo = 0, _transitType, _status, _search) => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getAllAgencies(token, pageSize, pageNo, _transitType, _status, _search)
                .then((res) => {
                    if (res?.code && res.code === 200) {
                        setAgencies(res?.data?.agencies);
                        // calcPagination(res.data?.totalRecord);
                        setTotalRecords(res.data?.totalRecord);
                    }
                })
                .catch((err) => {});
        }
    };

    const handleDelete = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .deleteAgency(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Agency has been deleted successfully.');
                        getAllAgencies();
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Logo</span>
                </h6>
            ),
            // selector: (row) => <img className="img-fluid" src={require('../../assets/images/icons/side-nav-logo.png')} width={150} />,
            selector: (row) => <img className="img-fluid table-image" src={row.logo} />,
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold ">Total Routes</span>
                </h6>
            ),
            selector: (row) => row.noOfRoutes,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Transit Type</span>
                </h6>
            ),
            selector: (row) => (row.transit_mediums.length > 0 ? row.transit_mediums.join(', ')?.toUpperCase() : row.transit_mediums[0]?.toUpperCase()),
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Commuters</span>
                </h6>
            ),
            selector: (row) => row.noOfCommuters || 0,
            sortable: true,
            center: true,
            minWidth: '140px'
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <div>
                    <select
                        value={row?.status}
                        onChange={(e) => {
                            e.preventDefault();
                            updateSingle(row?._id, { status: e.target.value });
                        }}
                        className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                        aria-label="Default select example"
                    >
                        <option value={'active'}>Active</option>
                        <option value={'inactive'}>Inactive</option>
                    </select>
                </div>
            ),
            center: true,
            // sortable: true
            minWidth: '130px',
            headerStyle: (selector, id) => {
                return { width: '500px', textAlign: 'center' };
            }
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex justify-content-center align-content-center">
                    <div className="view-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/agencies/agency-detail', {
                                            state: {
                                                agency_id: row._id,
                                                agency_details: row
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>

                    {/* <div className="edit-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Edit</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={editIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/agencies/edit-agency', {
                                            state: {
                                                agency_id: row._id,
                                                agency_details: row
                                            }
                                        });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>

                    <div className="del-detail">
                        <OverlayTrigger placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={delIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        setShowDelModal(true);
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div> */}
                </div>
            ),
            center: true
            // sortable: true
        }
    ];

    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        },
        cells: {
            style: {
                paddingLeft: '8px', // override the cell padding for data cells
                paddingRight: '8px'
            }
        }
    };

    const handlePageChange = (pageNo) => {
        // fetchUsers(page);
        getAllAgencies(pageSize, pageNo);
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllAgencies(pageSize, pageNo);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        getAllAgencies(undefined, undefined, '', '', text);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkAgencies(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllAgencies();
                            setLoading(false);
                            toast.success(setSelectedRows?.length > 1 ? 'Agencies have been updated successfully.' : 'Agency has been updated successfully');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const updateSingle = async (selectedId, body) => {
        try {
            setLoading(true);
            const token = getToken();
            if (token)
                new WebApiCalls()
                    .updateAgency(token, body, selectedId)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllAgencies();
                            setLoading(false);
                            toast.success('Agency has been updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkAgencies(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllAgencies();
                            setLoading(false);
                            toast.success(selectedRows.length > 1 ? 'Agencies have been deleted successfully.' : 'Agency has been deleted successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                <Modal.Header closeButton onClick={handleClose}>
                    <Modal.Title className="text-center">
                        <h6 className="mt-2 modal-detail">Change Status</h6>
                        {/* Routes */}
                        {/* <hr></hr> */}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    <div className="icon-warning-wrapper my-1 mt-1">
                        <img src={warningIcon} alt="" />
                    </div>
                    <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                    <div className="text-content-wrapper mt-3">
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#198754' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('active');
                                }}
                            >
                                Active
                            </Button>
                        </div>
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#F32013' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('inactive');
                                }}
                            >
                                Inactive
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 mt-2"></Modal.Footer>
            </Modal>

            {/* Modal For deleting multiple agencies */}
            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Agency?'} />

            {/* Modal For deleting multiple agencies */}
            <CommonModal handleClose={handleClose} show={showBulkDel} handleDelete={deleteBulk} text={'Are you sure, you want to delete Agencies?'} />

            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }} className="my-3 my-sm-0">
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                        }}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                    <div className="d-flex gap-10 justify-content-start">
                        <h6 className="text-capitalize mt-2 text-center">
                            {/* <span className="fw-bold" style={{ whiteSpace: 'nowrap' }}>
                                Filter By
                            </span> */}
                        </h6>
                        <select
                            onChange={(e) => {
                                getAllAgencies(undefined, undefined, '', e.target.value);
                                setIsFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''}>Status</option>
                            <option value={'active'}>Active</option>
                            <option value={'inactive'}>Inactive</option>
                        </select>
                        <select
                            onChange={(e) => {
                                getAllAgencies(undefined, undefined, e.target.value);
                                setIsTypeFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isTypeFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''}>Transit Type</option>
                            <option value={'bus'}>Bus</option>
                            <option value={'streetcar'}>Street Car</option>
                            <option value={'subway'}>Subway</option>
                            <option value={'train'}>Train</option>
                        </select>
                    </div>
                </Col>
                <Col sm={5} md={5} className="my-3 my-sm-0">
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: '#F3D119', color: 'black' }}
                                    onClick={(e) => {
                                        // updateBulk('active');
                                        setChangeStatusModal(true);
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Change Status
                                    {/* {activeButton} */}
                                </Button>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        setShowBulkDel(true);
                                        // deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                        {/* <Button
                            className="add-record-btn justify-content-center  w-140"
                            style={{ background: '#13aa61' }}
                            onClick={(e) => {
                                navigate('add-agency');
                                // setActionType('add');
                                // setShowAddEditModal(true);
                            }}
                        >
                            Add
                        </Button> */}
                    </div>
                    {/* </Col> */}
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={agencies}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                // defaultSortFieldId={1}
            />
        </div>
    );
};
export default Agencies;
